module.exports = __webpack_public_path__ + "static/media/icon-rejected.db482f36.svg";